module.exports = __webpack_public_path__ + "static/media/step3.c2ead93d.jpg";